// extracted by mini-css-extract-plugin
export default {"item":"Complete_item__zwEaM","item-wp":"Complete_item-wp__0FOYT"};